import React, { useState } from 'react';
import DENTModalOverviewGeneralEndodonticButtons from './DENTModalOverviewGeneralEndodonticButtons';
import { ToothEndodontic } from '../../../../graphql/graphql';
import { EndodonticButtonOption } from '../../Helpers/endodontic/endodonticButtonOptions';
import DENTModalOverviewGeneralEndodonticTemperatureButtons from './DENTModalOverviewGeneralEndodonticTemperatureButtons';

interface Props {
	type: Extract<EndodonticButtonOption['value'], 'cold' | 'heat'>;
	onClose: () => void;
}

const DENTModalOverviewGeneralEndodonticTemperature = ({
	type,
	onClose,
}: Props) => {
	const [values, setValues] = useState<ToothEndodontic[typeof type]>();

	return (
		<DENTModalOverviewGeneralEndodonticButtons
			type={type}
			values={values}
			onClose={onClose}>
			<DENTModalOverviewGeneralEndodonticTemperatureButtons
				values={values}
				onChange={setValues}
			/>
		</DENTModalOverviewGeneralEndodonticButtons>
	);
};

export default DENTModalOverviewGeneralEndodonticTemperature;
